import { default as formatShortTime, getShortTimeFormat } from './formatShortTime';
import { getMinutes } from 'owa-datetime';
import { getShortHourFormat } from './formatShortHour';
import { localizedFormatter } from './localizedFormatter';
import type { GlobalCalendarLocale, OwaDate } from 'owa-datetime';

export function getShortHourOr24HourShortTimeFormat(
    dateFormat: string,
    timeFormat: string
): string {
    const is24Hours = timeFormat.indexOf('H') != -1;
    const getFormat = is24Hours ? getShortTimeFormat : getShortHourFormat;
    return getFormat(dateFormat, timeFormat);
}

/** Formatter used when minutes are zero. Shows only hour in 12h formats, and hour:00 in 24h formats. */
export const formatShortHourOr24HShortTime: (
    date: OwaDate | null | undefined,
    locale?: GlobalCalendarLocale
) => string =
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function localizedFormatter called at module scope is not allowed. This may cause unwanted side effects. */
    localizedFormatter(getShortHourOr24HourShortTimeFormat);

/**
 * Formats the given date as a short hour (ex 2 PM) if minutes are zero
 * or as a short time otherwise (ex 2:30 PM). Seconds are ignored.
 * Always uses short time if user settings ask for 24h formats.
 */
export default function formatShortHourOrTime(displayDate: OwaDate): string {
    const formatter = getMinutes(displayDate) ? formatShortTime : formatShortHourOr24HShortTime;
    return formatter(displayDate);
}
